export function formatNOK(amount: number): string {
	return new Intl.NumberFormat('nb-NO', {
		style: 'currency',
		currency: 'NOK',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(amount)
}
